<template>
	<div>
		<TriangleImage
			v-show="$root.source !== 'bennet'"
			:title="'Come funziona la Spesa Online con Quomi'"
			:subtitle="'Kit Ricette, Cassette di Frutta e Verdura e tanti prodotti per una spesa online su misura e sostenibile'"
		/>

		<payoff :partner="true" v-show="$root.source === 'bennet'"  @scroll-to-div="scrollToDivId('plans')"/>

		<div class="container">
			<div class="content">
				<section class="px-5 center">
					<p>
						<span v-html="$root.source === 'bennet' ? 'Instacook' : 'Quomi'"/> è il servizio di <b v-html="$root.source === 'bennet' ? 'Bennet' : 'spesa online'"/> 
						che ti offre <b>ricette nuove ogni settimana</b> <span v-if="$root.source !=='bennet'"> e prodotti selezionati di <b>bottega</b></span> per completare la spesa. Gli ingredienti freschi arrivano 
						<b>dal produttore direttamente a casa tua</b>. La sostenibilità è al centro del servizio: <b>meno sprechi di cibo, packaging riciclabile o compostabile
						</b>, ingredienti stagionali e <b>un albero piantato per ogni ordine</b> spedito. Sei pronto a provare una nuova esperienza in cucina?
					</p>
				</section>
				
				<ContinueToShop />


				<div  id="plans" class="plans-options" v-if="$root.source === 'bennet'">
					<div class="flex flex-column align-items-center">
						<div class="shadow-box mb-3">
							<h2 class="center">Box coppia</h2>
							<p>Ideale per:</p>
							<p><i class="fas fa-check pr-2"/> 2 adulti</p>
							<p><i class="fas fa-check pr-2"/> 1 adulto e 1-2 bambini</p>
							<CTA
								:content="`Scegli le ricette`"
								style="margin-bottom: 0"
								@click="goAhead(2)"
							/>
						</div>
          	<span class="text-bold">A partire da 4,45€ a porzione!</span>
        	</div>
					<div class="flex flex-column align-items-center">
						<div class="shadow-box mb-3">
							<h2 class="center">Box famiglia</h2>
							<p>Ideale per:</p>
							<p><i class="fas fa-check pr-2"/> 4 adulti</p>
							<p><i class="fas fa-check pr-2"/> 2 adulti e 2-3 bambini</p>
							<CTA
								:content="`Scegli le ricette`"
								style="margin-bottom: 0"
								@click="goAhead(4)"
							/>
						</div>
						<span class="text-bold">A partire da 4,45€ a porzione!</span>
        	</div>
				</div>

				<!-- <plans only-kit-pricing style="min-height: unset"/> -->
				<!-- <h2 class='center'>Ecco come funziona:</h2> -->

				<section class="shop-section" v-if="$root.source !== 'bennet'">
					<!-- <div class="image">
						<img src="https://api.quomi.it/oldimg/ordine-quomi-spesa-online.webp">
					</div>

					<div class="description">
						<h2>1. Scegli i tuoi prodotti preferiti</h2>
						<p>Su Quomi puoi ordinare i comodi <b>Kit Ricetta</b> dal menù settimanale, le <b>cassette di frutta e verdura di stagione</b> e tanti altri kit e prodotti sempre di qualità certificata: <b>vini, olio, latticini e tanto altro.</b></p>
					</div> -->
					<div class="image">
						<img :src=" $root.source === 'bennet' ? 'https://api.quomi.it/oldimg/consegna-bennet-instacook.webp' : 'https://api.quomi.it/oldimg/Homepage2.png'" alt="bottega">
					</div>
					<div class="text-center">
						<h2 class="text-center" v-html="$root.source === 'bennet' ? 'Scegli le tue ricette' : 'Completa la tua spesa!'"/>
						<p class="px-3 text-center">
							<span v-html="$root.source === 'bennet' ? 'In ogni ricetta che selezionerai avrai la sicurezza di ricevere ' : 'Una <b>bottega con</b>'"></span>
							una selezione di <b>prodotti artigianali e di qualità</b>. Pesce da allevamenti sostenibili, frutta e verdura senza OGM, carne senza aggiunta di ormoni o antibiotici. 
							Direttamente <b>dal produttore alla tua tavola</b>.
							<span v-if="$root.source === 'bennet'">In più potrai ritrovare tutta la qualità dei prodotti alimentari di dispensa a marchio Bennet o Selezione Gourmet Bennet.</span>
						</p>
					</div>
				</section>

				<!-- <hr> -->

				<section class="abo-section flex flex-column align-items-center tag-partner">
				<!-- 	<div class="description">
						<h2>2. Facciamo la spesa per te</h2>
						<p>Una volta ricevuto il tuo ordine, confermiamo le quantità e riceviamo <b>direttamente dai nostri produttori</b>, i prodotti da te scelti. Evitiamo così sprechi di cibo in magazzino e ti garantiamo la massima freschezza e qualità.</b></p>
					</div>

					<div class="image">

						<img src="https://api.quomi.it/oldimg/cassetta-frutta-e-verdura.webp">

						<br><router-link :to="{ name: 'suppliers' }" class="link">Scopri da dove vengono i nostri ingredienti</router-link>

					</div> -->
						<h2 class="text-center">Con l’abbonamento hai comodità e risparmio!</h2>
						<span class=" abo-cards flex justify-content-between">
							<div 
								v-for="(card, index) in aboCards" 							
								:key="index"
								class="flex flex-column align-items-center col-12 col-md-6"
							>
								<span>
									<v-img
										max-width="200px"
										max-height="100%"
										:src="$root.source === 'bennet' ? card.srcPartner : card.src "
									/>
								</span>
								<h6 class="text-center text-bold">{{card.title}}</h6>
								<p class="text-center">{{card.text}}</p>
							</div>					
						</span>
				</section>

        <!-- <section v-else>

          <div class="image">

            <img src="https://api.quomi.it/oldimg/Cassetta-mista-large-quomi.webp">

            <br><router-link :to="{ name: 'suppliers' }" class="link">Scopri da dove vengono i nostri ingredienti</router-link>

          </div>
          <div class="description">
            <h2>2. Facciamo la spesa per te</h2>
            <p>Una volta ricevuto il tuo ordine, confermiamo le quantità e riceviamo <b>direttamente dai nostri produttori</b>, i prodotti da te scelti. Evitiamo così sprechi di cibo in magazzino e ti garantiamo la massima freschezza e qualità.</b></p>
          </div>
        </section> -->
				<!-- <hr> -->

				<!-- <section>
					<div class="image"><img src="https://api.quomi.it/oldimg/Cassetta-mista-large-quomi.webp">
						<br>
						<router-link :to="{ name: 'how-we-recycle' }" class="link">Scopri come riciclare la tua box</router-link>
					</div>

					<div class="description">
						<h2>3. Ricevi a casa la Food Box</h2>
						<p>Ti consegniamo la spesa nel <b>giorno e orario</b> che ci hai indicato. La nostra box è pensata per garantire la <b>qualità e freschezza</b> di tutti gli ingredienti. In più avrai anche le schede delle ricette per seguire le istruzioni passo passo.</p>
					</div> 
				</section> -->

				<div>
					<h3>Cosa aspetti? Fai ora la tua prima spesa online e sostenibile con noi!</h3>				
					<router-link
						v-if="$root.source !== 'bennet'"
						:to="{ name: 'flow-subscribed' }"
						class="flex-center"
					>
						<CTA
							:content="`Ordina ora`"
							isArrow
						/>
					</router-link>
				</div>

				<div class="contacts mt-10">
					<h2 class="text-center">Siamo a tua disposizione</h2>
					<p>Vuoi sapere di più sul servizio? Non esitare a contattarci, il nostro customer care è attivo dal lunedì al venerdì dalle 09.00 alle 18.00. Ecco i nostri contatti:</p>
					<ul class="contacts-list flex-column flex-center">
						<li><img src="../../assets/img/how/envelope.png" class="icon-contact">E-mail: <a :href="$root.source === 'bennet' ? 'mailto:instacook@quomi.it' : 'mailto:info@quomi.it'" v-html=" $root.source === 'bennet' ? 'instacook@quomi.it' :'info@quomi.it'"/></li>
						<li v-if="$root.source == 'bennet'"><img src="../../assets/img/how/phone-call.png" class="icon-contact">&nbsp N. Telefono: 02-87156618</li>
						<span v-else class="flex flex-column align-items-center">
							<li><img src="../../assets/img/how/phone-call.png" class="icon-contact">Telefono: 02-80889266</li>
							<li>
								<a target="_blank" href="https://api.whatsapp.com/send?phone=390280889266" style="text-decoration: none">
									<v-btn
										rounded
										color="#4AC959"
										class="white--text"
									>
										<v-icon left light>fab fa-whatsapp</v-icon>
										Scrivici su Whatsapp
									</v-btn>
								</a>
							</li>
						</span>
					</ul>
				</div>
			</div>

			<BigUsp>
			<template slot="icon"><i class="fa fa-question-circle fa-4x" aria-hidden="true" /></template>
			<template slot="title">Domande frequenti</template>
			<template slot="message">
				<p>Se hai ancora qualche dubbio, visita la nostra sezione <router-link :to="{name: 'faq'}" class="link" title="Domande frequenti">domande frequenti</router-link><br>oppure scrivici in chat, la trovi qui a destra</p>
			</template>
		</BigUsp>

			<StartWithUs @scroll-to-div="scrollToDivId('plans')"/>
		</div>

	</div>
</template>

<script>

import TriangleImage from '../TriangleImage'
import HowQuomiWorks from '../Parts/HowQuomiWorks'
import StartWithUs from '../Parts/StartWithUs'
import ContinueToShop from '../Parts/ContinueToShop'
import BigUsp from '../Parts/BigUsp'
import Plans from '../Plans'
import NewsletterModal from '../Parts/NewsletterModal'
import Payoff from '../Parts/Payoff'
import { scrollToElementId } from '../../assets/js/main'
import {container} from '../../services/container'

export default {
	components: {
		TriangleImage,
    ContinueToShop,
		StartWithUs,
		BigUsp,
		HowQuomiWorks,
		Plans,
		NewsletterModal,
		Payoff
	},
	data() {
		return {
			aboCards: [
				{
					title: "Personalizza la tua box",
					text: "Scegli la composizione base della tua box. Puoi modificarla in qualsiasi momento.",
					src: "https://api.quomi.it/oldimg/ICONA_1-%282%29.png",
					srcPartner: "https://api.quomi.it/oldimg/bennet-calendario.webp"
				},
				{
					title: "Scegli la frequenza",
					text: "Imposta la frequenza e il giorno di consegna. Puoi sospenderti con un click, senza vincoli, quando vuoi.",
					src: "https://api.quomi.it/oldimg/ICONA_2-%281%29.png",
					srcPartner: "https://api.quomi.it/oldimg/calendario-bennet.webp"
				},
				{
					title: "Consegna sempre gratuita",
					text: "Con l'opzione in abbonamento avrai sempre la consegna gratuita sui tuoi ordini ricorrenti!",
					src: "https://api.quomi.it/oldimg/ICONA_3-%281%29.png",
					srcPartner: "https://api.quomi.it/oldimg/consegna-bennet.webp"
				},
			]
		}
	},
	computed: {
		headerPartner() {
			return 'background-image: url("https://api.quomi.it/oldimg/1200x800_comefunziona_bennet.webp"); background-position: center 70%;'
		}
	},
	methods: {
		goAhead (people) {
      var cookies = container.get('services.cookies')

      cookies.set('people', people)

			this.$router.push({ name: 'flow-subscribed' })
		},

		scrollToDivId (target) {
				scrollToElementId(target,300,50)
			},
	}
}

</script>

<style scoped>
	.content {
		max-width: 1024px;
	}

	.content > section {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		
		margin: 0px auto 30px auto;
	}

	h2 {
		margin-bottom: 30px;
	}

	h3 {
		text-align: center;
	}

	.content > section > div {
		padding: 20px 0px;
		max-width: 470px;
		margin: 0 auto;
	}

	.content > section .image {
		text-align: center;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.contacts,
	.abo {
		display: flex;
		flex-direction: column;
		align-self: start;
	}

	.calendar {
		margin: 10px 0;
	}

	.contacts-list {
		list-style: none;
		text-align: left;
		width: 100%;
	}

	.contacts-list li {
		padding: 10px 0;
	}

	.triangle-image {
		background-image: url("../../assets/img/covers/mealkit.jpg");
		background-position: center center;
	}

	.fa-question-circle,
	.fa-check {
		color: var(--quomi-primary);
	}

	.plans-options {
    width: 100%;
		display: flex;
    justify-content: space-evenly;
		margin: 50px 0;
  }

	.shadow-box {
    padding: 15px 3rem;
    margin: 15px;
  }

	@media (max-width: 468px) {
  .plans-options {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
		margin: 30px 0 50px 0;
  }

	.plans-options div:first-child {
		margin-bottom: 20px;
  }

  .shadow-box {
    padding: 15px 20px;
    margin: 15px ;
  }
}

	@media(max-width: 768px) {
		.abo-cards {
			flex-direction: column;
		}
	}
</style>
